export const LISTEN_FOR_CONVO_LOAD_COMPLETE = "LISTEN_FOR_CONVO_LOAD_COMPLETE";

export const listenForConvoLoadCompleteAC = () => ({
    type: LISTEN_FOR_CONVO_LOAD_COMPLETE,
});